import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { Oops } from '@/pages/oops/oops';
import { Access } from '@/auth/access';
import { authChildGuard, authGuard } from '@/core/auth.guard';
import { MobileLayout } from '@/mobile/mobile-layout/mobile-layout';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        canActivateChild: [authChildGuard],
        children: [
            { path: '', redirectTo: 'pages', pathMatch: 'full' },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes')
            }
        ]
    },
    {
        path: 'mobile',
        component: MobileLayout,
        canActivate: [authGuard],
        canActivateChild: [authChildGuard],
        children: [
            { path: '', loadComponent: () => import('@/mobile/mobile-home/mobile-home').then((c) => c.MobileHome), data: { title: '' } },
            { path: 'separacao', loadComponent: () => import('@/mobile/picking/picking-scan').then((c) => c.PickingScan), data: { title: 'Separação', permissions: ['sales.order.separate'] } },
            { path: 'armazenagem', loadComponent: () => import('@/mobile/storage/mobile-storage-list/mobile-storage-list').then((c) => c.MobileStorageList), data: { title: 'Armazenagem', permissions: ['stock.storage.view'] } },
            { path: 'armazenagem/:id', loadComponent: () => import('@/mobile/storage/mobile-storage-scan/mobile-storage-scan').then((c) => c.MobileStorageScan), data: { title: 'Armazenagem', permissions: ['stock.storage.create'] } },
            { path: 'inventario', loadComponent: () => import('@/mobile/inventory/mobile-inventory-list/mobile-inventory-list').then((c) => c.MobileInventoryList), data: { title: 'Inventário', permissions: ['stock.inventory.view'] } },
            { path: 'inventario/:id', loadComponent: () => import('@/mobile/inventory/mobile-inventory-address-list/mobile-inventory-address-list').then((c) => c.MobileInventoryAddressList), data: { title: 'Endereços', permissions: ['stock.inventory.view'] } },
            {
                path: 'inventario/:id/endereco/:inventoryAddressId',
                loadComponent: () => import('@/mobile/inventory/mobile-inventory-count/mobile-inventory-count').then((c) => c.MobileInventoryCount),
                data: { title: 'Contagem', permissions: ['stock.inventory.count'] }
            }
        ]
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('@/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('@/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () => import('@/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('@/auth/forgotpassword').then((c) => c.ForgotPassword)
            },
            {
                path: 'new-password',
                loadComponent: () => import('@/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                loadComponent: () => import('@/auth/lockscreen').then((c) => c.LockScreen)
            },
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'access-denied', component: Access },
    { path: 'oops', component: Oops },
    { path: '**', redirectTo: '/notfound' }
];
